// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3coof","sendOtp":"AuthorizeToLogin_sendOtp__354O8"};